import { SsoTokens } from '@/types/ssoTokens';
import { api } from '@/services/api/axios/instance';
import { stopCapyRefreshing } from '@/components/shared/CapyCaptcha';

type ResetTokenCallParams = {
  data: {
    email: string;
    capyChallengekey: string;
    capyAnswer: string;
  };
};

type GetSsoTokensParams = {
  data: {
    gpc: string;
    gss: string;
    gul: string;
  };
};

export const adminApi = {
  sendVerificationMail: async (config: ResetTokenCallParams): Promise<void> => {
    const { data } = config;
    const path = `admin/reset_password_token_call`;
    await api.post(path, {
      ...data,
      email: data.email.trim(),
    });
    stopCapyRefreshing();
  },
  activateAccountMail: async (params: ResetTokenCallParams): Promise<void> => {
    const { data } = params;
    const path = `admin/account_activation_email`;
    await api.post(path, {
      ...data,
      email: data.email.trim(),
    });
    stopCapyRefreshing();
  },
  confirmToken: async (
    confirm_email_token: string | undefined,
  ): Promise<void> => {
    const path = `admin/validate_confirm_email_token`;

    await api.get(path, {
      headers: { 'x-v2-admin-activate-token': `Bearer ${confirm_email_token}` },
    });
  },
  confirmResetPasswordToken: async (
    confirm_reset_password_token: string,
  ): Promise<void> => {
    const path = `admin/validate_reset_password_token`;

    await api.get(path, {
      headers: {
        'x-v2-admin-reset-password-token': `Bearer ${confirm_reset_password_token}`,
      },
    });
  },
  getSsoTokens: async (config: GetSsoTokensParams): Promise<SsoTokens> => {
    const { data, ...requestConfig } = config;
    const { gpc, gss, gul = 'ja' } = data;
    const path = `admin/single-sign-on`;

    const response = await api.get(path, {
      ...requestConfig,
      params: {
        gpc,
        gss,
        gul,
      },
    });

    return response.data;
  },
  getReAuthenticationExpiration: async (): Promise<Date | null> => {
    const path = `admin/re_authentication_expiration`;
    const response = await api.get(path);
    return response.data.reAuthenticationExpiredAt;
  },
};
